import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-editor-mapeamento',
  templateUrl: './editor-mapeamento.component.html',
  styleUrl: './editor-mapeamento.component.css'
})
export class EditorMapeamentoComponent {

  @Input() mapeamentos: { [key: string]: string } = {};
  @Input() camposOrigem: string[] = [];
  @Input() disabled: boolean = false;
  @Input() titulo: string = 'Mapeamento de Campos';

  @Output() mapeamentosAlterados = new EventEmitter<{ [key: string]: string }>();

  // Lista de mapeamentos para exibição na tabela
  mapeamentosList: { origem: string; destino: string }[] = [];

  // Novo mapeamento sendo adicionado
  novoMapeamento = { origem: '', destino: '' };

  ngOnInit(): void {
    this.atualizarLista();
  }

  ngOnChanges(): void {
    this.atualizarLista();
  }

  /**
   * Converte objeto de mapeamentos para lista
   */
  atualizarLista(): void {
    this.mapeamentosList = Object.entries(this.mapeamentos).map(([origem, destino]) => ({
      origem,
      destino
    }));
  }

  /**
   * Adicionar novo mapeamento
   */
  adicionarMapeamento(): void {
    if (this.novoMapeamento.origem && this.novoMapeamento.destino) {
      // Verificar se já existe
      if (this.mapeamentos[this.novoMapeamento.origem]) {
        // Sobrescrever
        this.mapeamentos[this.novoMapeamento.origem] = this.novoMapeamento.destino;
      } else {
        // Adicionar novo
        this.mapeamentos[this.novoMapeamento.origem] = this.novoMapeamento.destino;
      }

      // Limpar formulário
      this.novoMapeamento = { origem: '', destino: '' };

      // Atualizar lista e emitir evento
      this.atualizarLista();
      this.emitirAlteracao();
    }
  }

  /**
   * Remover mapeamento
   */
  removerMapeamento(origem: string): void {
    delete this.mapeamentos[origem];
    this.atualizarLista();
    this.emitirAlteracao();
  }

  /**
   * Editar mapeamento inline
   */
  editarMapeamento(mapeamento: { origem: string; destino: string }, novoDestino: string): void {
    this.mapeamentos[mapeamento.origem] = novoDestino;
    this.emitirAlteracao();
  }

  /**
   * Emitir evento de alteração
   */
  emitirAlteracao(): void {
    this.mapeamentosAlterados.emit({ ...this.mapeamentos });
  }

  /**
   * Verificar se campo origem já foi mapeado
   */
  campoJaMapeado(campo: string): boolean {
    return campo in this.mapeamentos;
  }
}
